module.exports = __webpack_public_path__ + "static/leader3-9dc6d9167d7cd235fb053ae068d7883b.svg";